import constructActionTypes from 'common/utils/constructActionTypes';

// Using module.exports so that `import { KEY_NAME } from './constants/actionTypes'` works
const actionTypes = constructActionTypes(
    {
        OPENED_ADD_TO_HUB_MODAL: null,
        CLOSED_ADD_TO_HUB_MODAL: null,
        SET_SELECTED_EVENTS: null,
        FETCH_HUBS_REQUEST: null,
        FETCH_HUBS_SUCCESS: null,
        FETCH_HUBS_ERROR: null,
        SET_SEARCH_TERM: null,
        SET_SORT_MODE: null,
        ADD_TO_HUBS_REQUEST: null,
        ADD_TO_HUBS_SUCCESS: null,
        ADD_TO_HUBS_ERROR: null,
        SELECT_HUB: null,
        UNSELECT_HUB: null,
        SELECT_ALL_HUBS: null,
        UNSELECT_ALL_HUBS: null,
        CLEAR_NOTIFICATION_MESSAGE: null,
    },
    'addToHubModal',
);

export { actionTypes as default };
